// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-rules/order-rules.less
// module id = 3594
// module chunks = 0